import {
  HttpContext,
  HttpContextToken,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

export const ALLOW_HAL = new HttpContextToken<boolean>(() => false);

export function allowHal(): HttpContext {
  return new HttpContext().set(ALLOW_HAL, true);
}

@Injectable()
export class HalAcceptInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (request.context.get(ALLOW_HAL)) {
      return next.handle(request);
    }
    const accept = request.headers.get('Accept');
    if (accept && accept.includes('application/hal+json')) {
      return next.handle(
        request.clone({
          setHeaders: { Accept: 'application/json' },
        })
      );
    }
    return next.handle(request);
  }
}
